var r = /* @__PURE__ */ ((i) => (i.Inline = "inline-image", i.Block = "block-image", i))(r || {}), o = /* @__PURE__ */ ((i) => (i.Inline = "inline", i.BlockCenter = "blockCenter", i.BlockRight = "blockRight", i))(o || {}), n = /* @__PURE__ */ ((i) => (i.Before = "before", i.After = "after", i))(n || {}), k = /* @__PURE__ */ ((i) => (i[i.InitialMode = 0] = "InitialMode", i[i.ViewLinkMode = 1] = "ViewLinkMode", i.EditCaptionMode = "caption", i.EditAltMode = "alt", i.EditLinkMode = "href", i))(k || {});
export {
  k as ImageBubbleMenuState,
  o as ImageModeEnum,
  r as ImageNameEnum,
  n as InsertParagraphEnum
};
